import React from "react";
import HolyGrailLayout from "../../components/HolyGrailLayout";

export default function DevLeave() {
  return (
    <HolyGrailLayout>
      <h1>开发者离开</h1>
    </HolyGrailLayout>
  );
}